<script setup lang="ts">
import { computed } from "vue";
import { useRouter } from "vue-router";
import { useWeight } from "@/composables/tasks/challenge/useChallengeWeight";

import WeightRecordsTable from "@/components/v2/Tasks/Challenge/Tables/WeightRecordsTable.vue";
import FooterActions from "@/components/v2/Tasks/Challenge/Buttons/ActionButtons/FooterActions.vue";

const router = useRouter();
const goBack = () => router.go(-1);

const { weightRecords } = useWeight();

const totalRecords = computed(() => weightRecords.value.length);

const averageWeight = computed(() => {
    if (!weightRecords.value.length) return 0;
    const sum = weightRecords.value.reduce((acc, record) => acc + record.weight, 0);
    return Math.round((sum / weightRecords.value.length) * 100) / 100;
});

</script>

<template>
    <div class="flex flex-col h-full justify-between">
        <div class="space-y-6">
            <!-- Header -->
            <div class="flex justify-between items-center">
                <h1 class="text-2xl font-bold text-gray-800">Weight Records</h1>
                <button
                    @click="goBack"
                    class="text-gray-600 hover:text-gray-800 flex items-center gap-1 text-sm"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M19 12H5M12 19l-7-7 7-7"/>
                    </svg>
                    Back
                </button>
            </div>

            <span class="w-full bg-secondary h-[1px] block"></span>

            <!-- Stats Cards -->
            <div class="grid grid-cols-2 gap-4">
                <div class="bg-white p-4 rounded-lg shadow-sm border border-gray-200">
                    <h3 class="text-sm font-medium text-gray-500 mb-1">Total Records</h3>
                    <p class="text-2xl font-bold text-gray-800">{{ totalRecords }}</p>
                </div>
                <div class="bg-white p-4 rounded-lg shadow-sm border border-gray-200">
                    <h3 class="text-sm font-medium text-gray-500 mb-1">Average Weight</h3>
                    <p class="text-2xl font-bold text-gray-800">{{ averageWeight }}g</p>
                </div>
            </div>

            <!-- Table -->
            <div class="bg-white p-4 rounded-lg shadow-sm border border-gray-200">
                <h2 class="text-lg font-semibold text-gray-800 mb-4">Weight Measurement History</h2>
                <WeightRecordsTable :records="weightRecords" />
            </div>
        </div>

        <!-- Footer -->
        <FooterActions>
            <template #middle>
                <button
                    @click="goBack"
                    class="w-full"
                >
                    Back
                </button>
            </template>
        </FooterActions>
    </div>
</template>